<template>
  <v-card>
    <v-card-text>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 md6>
              <v-text-field label="รหัสกลุ่ม" v-model="sectionItem.code" :rules="[rules.required]" required :readonly="!allowedRoles"></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field label="ชื่อกลุ่ม" v-model="sectionItem.name" :rules="[rules.required]" required :readonly="!allowedRoles"></v-text-field>
            </v-flex>
            <v-flex xs12 md3>
              <v-select
                :items="dayItems"
                v-model="sectionItem.day"
                label="วันที่สอน"
                :rules="[rules.required]"
                required
                :readonly="!allowedRoles"
              ></v-select>
            </v-flex>
            <v-flex xs6 md3>
              <v-menu
                ref="menuStartTime"
                :close-on-content-click="false"
                v-model="menuStartTime"
                :nudge-right="40"
                :return-value.sync="sectionItem.startTime"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
                :readonly="!allowedRoles"
              >
                <v-text-field
                  slot="activator"
                  v-model="sectionItem.startTime"
                  label="เวลาเริ่มต้น"
                  prepend-icon="access_time"
                  readonly
                ></v-text-field>
                <v-time-picker v-model="sectionItem.startTime" format="24hr" @change="$refs.menuStartTime.save(sectionItem.startTime)" :readonly="!allowedRoles"></v-time-picker>
              </v-menu>
            </v-flex>
            <v-flex xs6 md3>
              <v-menu
                ref="menuEndTime"
                :close-on-content-click="false"
                v-model="menuEndTime"
                :nudge-right="40"
                :return-value.sync="sectionItem.endTime"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
                :readonly="!allowedRoles"
              >
                <v-text-field
                  slot="activator"
                  v-model="sectionItem.endTime"
                  label="เวลาสิ้นสุด"
                  prepend-icon="access_time"
                  readonly
                ></v-text-field>
                <v-time-picker v-model="sectionItem.endTime" format="24hr" @change="$refs.menuEndTime.save(sectionItem.endTime)" :readonly="!allowedRoles"></v-time-picker>
              </v-menu>
            </v-flex>
            <v-flex xs6 md3>
              <v-text-field label="จำนวนชั่วโมง" v-model="sectionItem.hours" disabled></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-autocomplete
                :items="roomItems"
                v-model="sectionItem.room"
                label="ห้องเรียน"
                item-value="id"
                item-text="label"
                return-object
                clearable
                :readonly="!allowedRoles"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md12>
              <v-autocomplete
                :items="personItems"
                v-model="sectionItem.instructors"
                label="อาจารย์ที่ปรึกษากลุ่ม"
                item-value="id"
                item-text="fullname"
                return-object
                multiple
                chips
                :rules="[v => !!v || 'Item is required']" 
                required
                :readonly="!allowedRoles"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn color="grey white--text" :loading="loading" :disabled="loading" @click.native="back()">กลับ</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="success" :loading="loading" :disabled="loading" @click.native="onSubmit" v-if="allowedRoles">บันทึก</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import swal from 'sweetalert2'

export default {
  props: ['sectionItem', 'allowedRoles'],
  data () {
    return {
      dayItems: [ 'วันจันทร์', 'วันอังคาร', 'วันพุธ', 'วันพฤหัสบดี', 'วันศุกร์', 'วันเสาร์', 'วันอาทิตย์'],
      loading: false,
      valid: false,
      rules: {
        required: (value) => !!value || 'ไม่สามารถเป็นค่าว่าง'
      },
      menuStartTime: false,
      startTime: null,
      menuEndTime: false,
      endTime: null
    }
  },
  computed: {
    ...mapGetters({
        personItems: 'person/personItems',
        roomItems: 'roomItems'
    })
  },
  mounted () {

  },
  methods: {
    back () {
      // this.$router.go(-1)
      this.$router.push({ name: 'section', params: { activeCourseId: this.sectionItem.activeCourse.id, allowedRoles: this.allowedRoles }})
    },
    clear () {
      
    },
    close: function() {
      this.$emit('dialog', false)
    },
    onSubmit () {
      if (this.$refs.form.validate()) {
        this.loading = true
        let dispatch = this.sectionItem.id && this.sectionItem.id > 0 ? 'section/update' : 'section/create'
        this.$store.dispatch(dispatch, this.sectionItem)
          .then((response) => {
            // console.log('onSave:', response )
            this.loading = false
            swal({
              title: 'Success!',
              type: 'success'
            }).then(response => {
              this.close()
            })
          }).catch((error) => {
            this.loading = false
            swal('Error!', error.message, 'error')
          })
      }
    }
  },
  watch: {
    'sectionItem.startTime' (val) {
      if(this.sectionItem.endTime) {
        if( moment( val, "kk:mm" ) >= moment( this.sectionItem.endTime, "kk:mm" ) ) {
          this.$store.dispatch('storeAlertOnFail', 'เวลาเริ่มต้นไม่ควรมากกว่าเวลาสิ้นสุด')  
        } else {
          this.sectionItem.hours = moment.duration( moment( this.sectionItem.endTime, "kk:mm" ) - moment( this.sectionItem.startTime, "kk:mm" ) ).asHours()
        }
      }
    },
    'sectionItem.endTime' (val) {
      if(this.sectionItem.startTime) {
        if( moment( val, "kk:mm" ) <= moment( this.sectionItem.startTime, "kk:mm" ) ) {
          this.$store.dispatch('storeAlertOnFail', 'เวลาสิ้นสุดไม่ควรน้อยกว่าเวลาเริ่มต้น')  
        } else {
          this.sectionItem.hours = moment.duration( moment( this.sectionItem.endTime, "kk:mm" ) - moment( this.sectionItem.startTime, "kk:mm" ) ).asHours()
        }
      }
    }
  }
}

</script>


// WEBPACK FOOTER //
// src/components/management/course/section/shows/section/index.vue